import React from 'react';
import {
  StyledFlex,
  StyledSpan,
  StyledTextLabel,
  StyledTextValueWrapper,
} from '../StyledComponents';

export const DetailsRow = ({ label, value, dataCy = '', width = 100, boldValue = false }) => {
  return (
    <StyledFlex {...(dataCy ? { 'data-cy': dataCy } : {})} width={`${width}%`}>
      <StyledTextLabel>{label}</StyledTextLabel>
      <StyledTextValueWrapper>
        <StyledSpan boldValue={boldValue}>{value}</StyledSpan>
      </StyledTextValueWrapper>
    </StyledFlex>
  );
};
